import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { useEffect } from 'react'
import { isEmpty } from 'lodash'
import { $isRootTextContentEmpty } from '@lexical/text'

export const TempSavePlugin = ({ threadId }: { threadId?: string }) => {
    const [editor] = useLexicalComposerContext()

    useEffect(() => {
        if (!threadId) {
            return
        }
        const textSessionKey = `unsaved-text-${threadId}`
        const savedState = sessionStorage.getItem(textSessionKey)
        if (savedState) {
            editor.update(
                () => {
                    const editorState = editor.parseEditorState(savedState)
                    if (!isEmpty(editorState._nodeMap)) {
                        editor.setEditorState(editorState)
                    }
                },
                { discrete: true }
            )
        }

        return () => {
            editor.getEditorState().read(() => {
                if ($isRootTextContentEmpty(false, true)) {
                    sessionStorage.removeItem(textSessionKey)
                } else {
                    sessionStorage.setItem(textSessionKey, JSON.stringify(editor.getEditorState().toJSON()))
                }
            })
        }
    }, [editor, threadId])

    return null
}
